import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import "./InformationSection.css";
import banner from "../../assets/images/banner.webp";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function InformationSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ once: true, duration: 1000 });
  }, []);

  return (
    <section className="information-section">
      <Container>
        <Row className="align-items-center">
          {/* Text */}
          <Col xs={12} md={12} lg={12} data-aos="fade-right">
            <h2 className="information-title">
              {t("informationSection.title")}{" "}
              <span className="text-orange">
                {t("informationSection.titleHighlight")}
              </span>
            </h2>
            <p className="information-text text-center mt-4">
              {t("informationSection.description")}
            </p>
            <div
              className="d-flex justify-content-center mt-4"
              data-aos="zoom-in"
            >
              <button
                className="btn btn-primary px-4 py-2 pulse text-white"
                onClick={() => navigate("/contact")}
              >
                {t("informationSection.buttonText")}
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
